<!--
  转账
  lovi 2020-06-22
-->
<template>
  <div>
    <div class="scroll-wrapper">
      <div class="bg"></div>
      <scroll ref="scroll">
        <div class="column group-list">
          <van-cell
            icon="icon-add"
            :title="$t('transfer.addTransferGroup')"
            @click="addGroupFlag = true"
          />
          <div v-for="(item, index) in groupList" :key="index">
            <van-cell
              icon="icon-group"
              v-if="item.status"
              :title="item.group_name"
              :label="item.count + $t('common.persons')"
              @click="clickGroup(item)"
              is-link
            />
          </div>
        </div>
      </scroll>
    </div>

    <div class="button-wrap button-fixed">
      <van-button block type="primary" @click="toTransfer">
        {{ $t("transfer.immediatelyTransfer") }}
      </van-button>
    </div>

    <transition name="slide">
      <group-members
        v-if="groupMembersFlag"
        :groupMembersFlag.sync="groupMembersFlag"
        :data="groupData"
        @getListTransferGroup="getListTransferGroup"
      />
    </transition>

    <van-dialog
      v-model="addGroupFlag"
      :title="$t('transfer.setTransferGroupName')"
      show-cancel-button
      :beforeClose="createGroup"
    >
      <!-- <p class="changeTips">只能输入2-12个中英文或数字</p> -->
      <van-field
        class="dialog-input"
        :error="groupNameError ? true : false"
        @input="groupNameInput"
        :placeholder="$t('transfer.enterTransferGroupName')"
        v-model="groupName"
      />
    </van-dialog>

    <!-- 去转账 -->
    <transition name="slide">
      <transfer
        v-if="transferFlag"
        :transferFlag.sync="transferFlag"
        :list="transferList"
      />
    </transition>
  </div>
</template>

<script>
import * as validate from "@/commonJs/validate.js";
import GroupMembers from "./group/members";
import Transfer from "./transfer";
export default {
  components: {
    GroupMembers,
    Transfer
  },
  data() {
    return {
      groupList: [], // 群组列表
      addGroupFlag: false, // 添加群组Flag
      groupName: "", // 添加群组name
      groupNameError: false, // 添加群组error
      groupMembersFlag: false, // 群组成员Flag
      groupData: {}, // 群组data
      transferFlag: false, // 去转账
      transferList: []
    };
  },
  created() {
    this.getListTransferGroup();
  },
  mounted() {},
  computed: {},
  methods: {
    toTransfer() {
      // 立即转账
      this.transferFlag = true;
    },
    groupNameInput() {
      // 群昵称Input
      this.groupNameError = validate.validateGroupName(this.groupName);
    },
    clickGroup(data) {
      // 点击群组
      let vm = this;
      vm.groupMembersFlag = true;
      vm.groupData = data;
      console.log("clickGroup", data);
    },
    createGroup(action, done) {
      // 创建群组
      let vm = this;
      if (action === "confirm") {
        if (vm.groupName == "") {
          vm.$toast(vm.$t("transfer.enterTransferGroupName"));
          done(false);
          return;
        }
        if (vm.groupNameError) {
          vm.$toast(vm.groupNameError);
          done(false);
          return;
        }
        let params = {};
        params.group_name = vm.groupName;
        vm.$post("/app/transfer/addTransferGroup", params, {
          loading: true,
          alert: true
        }).then(res => {
          console.log("addTransferGroup", res);
          done();
          if (res.code == 0) {
            vm.getListTransferGroup();
          }
          vm.groupName = "";
          vm.$toast(res.msg);
        });
      } else {
        //点击取消 弹窗关闭
        vm.groupName = "";
        done();
      }
    },
    getListTransferGroup() {
      // 获取群组列表
      let vm = this;
      vm.$post(
        "/app/transfer/listTransferGroup",
        {},
        {
          loading: true
        }
      ).then(res => {
        console.log("listTransferGroup", res);
        vm.groupList = res.list;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.scroll-wrapper {
  background: #f4f4f4;
  bottom: 65px;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
}
.button-fixed {
  background: #f4f4f4;
}

.group-list {
  /deep/.van-cell {
    position: relative;
    align-items: center;
    &::after {
      content: "";
      position: absolute;
      left: 70px;
      right: 0;
      bottom: 0;
      border-bottom: 1.1px solid #e4e4e4;
    }
    .van-cell__left-icon {
      margin-right: 10px;
      width: 44px;
      height: 44px;
      background: #bde0ff;
      border-radius: 4px;
      background-image: url("@{images}wallet/transfer/icon_qunzu@2x.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 30px 30px;
      &.van-icon-icon-add {
        background: transparent;
        background-image: url("@{images}wallet/transfer/icon_add@2x.png");
        background-size: 44px 44px;
      }
    }
  }
}

.changeTips {
  text-align: center;
  font-size: 12px;
  color: #4a4a4a;
}
</style>
